import {loadCropsDetails} from './digidiary.service';
import {
  getFarmState,
  getUserIDState,
  callAPI,
  handleAlert,
  updateUserAggrement,
  updateUserTnCAccepted,
} from './sagaHelper';

import {
  DIGIDIARY_ADD_FARM,
  PUSH_DIGIDIARY_VIEW,
  DIGIDIARY_SET_LOADER,
  FARM_INFO_RESET,
  DIGIDIARY_GET_FARM_DATA,
  DIGIDIARY_UPDATE_MY_FARM,
  DIGIDIARY_TNC_ACCEPTED,
} from '../actions';

import {takeEvery, select, put, call} from 'redux-saga/effects';

export function* addFarmData({redirectView}) {
  let flag = true;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  const farmState = yield select(getFarmState);
  let customerId = yield select(getUserIDState);
  let payload = {...farmState};
  const response = yield call(callAPI, {
    method: 'post',
    url: `/farmDetails?customerId=${customerId}`,
    data: payload,
  });

  flag = false;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  if (response.statusCode && response.statusCode === 200) {
    let newView = redirectView;
    yield put({type: PUSH_DIGIDIARY_VIEW, newView});
    yield put({type: FARM_INFO_RESET});
    yield call(handleAlert, {
      variant: 'success',
      type: 'addFarmSuccess',
    });
    yield call(updateUserAggrement, {
      customerId: customerId,
      isFarmSetupCompleted: 'isFarmSetupCompleted',
    });
  } else {
    yield call(handleAlert, {
      variant: 'error',
      type: 'alertError',
    });
  }
}

export function* getFarmData() {
  const customerId = yield select(getUserIDState);
  let loadCropsData = [];

  loadCropsData = yield loadCropsDetails(customerId);

  const dataObj = {
    crops: loadCropsData?.data,
  };
  yield put({type: DIGIDIARY_UPDATE_MY_FARM, dataObj});
}

export function* updateDigiDiaryTnC({redirectView}) {
  let flag;
  if (redirectView) {
    flag = true;
    yield put({type: DIGIDIARY_SET_LOADER, flag});
  }

  let customerId = yield select(getUserIDState);

  const response = yield call(updateUserTnCAccepted, {
    customerId: customerId,
  });

  if (redirectView) {
    let newView = redirectView;
    flag = false;
    yield put({type: DIGIDIARY_SET_LOADER, flag});
    yield put({type: PUSH_DIGIDIARY_VIEW, newView});
  }
}

export function* addFarmDataSaga() {
  yield takeEvery(DIGIDIARY_ADD_FARM, addFarmData);
}

export function* getFarmDataSaga() {
  yield takeEvery(DIGIDIARY_GET_FARM_DATA, getFarmData);
}

export function* updateDigiDiaryTnCSaga() {
  yield takeEvery(DIGIDIARY_TNC_ACCEPTED, updateDigiDiaryTnC);
}
